import type { Supplier, OutreachRecord } from './schema'

// ============================================================
// SAMPLE PROFILES — clearly placeholder companies.
// Used only for UI preview. None of these are real partners.
// ============================================================

export const sampleSuppliers: Supplier[] = [
  {
    id: 'SP-0001',
    company_name: 'Gulf Coast Valve & Flow Systems',
    website: 'sample.example.com',
    state: 'TX',
    city: 'Houston',
    category: 'Valves & Flow Control',
    sub_category: 'Choke valves, manifolds, wellhead',
    products_services:
      'API 6A wellhead components, gate valves, choke manifolds, flow control assemblies',
    certifications: ['API 6A', 'API Q1', 'ISO 9001'],
    api_related: true,
    iso_certified: true,
    export_ready: true,
    latin_america_experience: true,
    spanish_support: true,
    source_directory: 'API Composite List',
    source_url: '',
    contact_name: '—',
    contact_email: '—',
    contact_phone: '—',
    verification_status: 'Pending Verification',
    notes: 'Sample Profile — placeholder record',
    last_contacted: '',
    relationship_status: 'Not Contacted',
  },
  {
    id: 'SP-0002',
    company_name: 'Lone Star Compression Equipment',
    website: 'sample.example.com',
    state: 'TX',
    city: 'Midland',
    category: 'Pumps & Compressors',
    sub_category: 'Reciprocating compressors, gas lift',
    products_services:
      'Reciprocating and screw compressors, gas lift packages, pump skids',
    certifications: ['ISO 9001', 'ASME'],
    api_related: true,
    iso_certified: true,
    export_ready: true,
    latin_america_experience: false,
    spanish_support: false,
    source_directory: 'Rigzone Directory',
    source_url: '',
    contact_name: '—',
    contact_email: '—',
    contact_phone: '—',
    verification_status: 'Pending Verification',
    notes: 'Sample Profile — placeholder record',
    last_contacted: '',
    relationship_status: 'Not Contacted',
  },
  {
    id: 'SP-0003',
    company_name: 'Houston Industrial Controls Group',
    website: 'sample.example.com',
    state: 'TX',
    city: 'Houston',
    category: 'Automation & Industrial Controls',
    sub_category: 'PLC, SCADA, instrumentation',
    products_services:
      'PLC systems, SCADA integration, field instrumentation, control panels',
    certifications: ['UL', 'ISO 9001'],
    api_related: false,
    iso_certified: true,
    export_ready: true,
    latin_america_experience: true,
    spanish_support: true,
    source_directory: 'Thomasnet',
    source_url: '',
    contact_name: '—',
    contact_email: '—',
    contact_phone: '—',
    verification_status: 'Invite Only',
    notes: 'Sample Profile — placeholder record',
    last_contacted: '',
    relationship_status: 'Researching',
  },
  {
    id: 'SP-0004',
    company_name: 'Louisiana Field Service Solutions',
    website: 'sample.example.com',
    state: 'LA',
    city: 'Lafayette',
    category: 'Refinery Maintenance & Repair',
    sub_category: 'Turnaround, field machining',
    products_services:
      'Refinery turnarounds, on-site machining, mechanical maintenance, inspection',
    certifications: ['OSHA', 'API 510', 'API 570'],
    api_related: true,
    iso_certified: false,
    export_ready: false,
    latin_america_experience: false,
    spanish_support: false,
    source_directory: 'Louisiana Oil & Gas Association',
    source_url: '',
    contact_name: '—',
    contact_email: '—',
    contact_phone: '—',
    verification_status: 'Pending Verification',
    notes: 'Sample Profile — placeholder record',
    last_contacted: '',
    relationship_status: 'Not Contacted',
  },
  {
    id: 'SP-0005',
    company_name: 'U.S. Methane Monitoring Technologies',
    website: 'sample.example.com',
    state: 'CO',
    city: 'Denver',
    category: 'Methane & Environmental Tech',
    sub_category: 'Leak detection, emissions monitoring',
    products_services:
      'Continuous methane monitoring, OGI cameras, emissions reporting platforms',
    certifications: ['EPA Natural Gas STAR', 'ISO 14001'],
    api_related: false,
    iso_certified: true,
    export_ready: true,
    latin_america_experience: false,
    spanish_support: false,
    source_directory: 'EPA Natural Gas STAR Directory',
    source_url: '',
    contact_name: '—',
    contact_email: '—',
    contact_phone: '—',
    verification_status: 'Pending Verification',
    notes: 'Sample Profile — placeholder record',
    last_contacted: '',
    relationship_status: 'Not Contacted',
  },
  {
    id: 'SP-0006',
    company_name: 'American Power Distribution Systems',
    website: 'sample.example.com',
    state: 'TX',
    city: 'Dallas',
    category: 'Electrical Infrastructure',
    sub_category: 'Transformers, switchgear, distribution',
    products_services:
      'Medium-voltage transformers, switchgear, power distribution panels, industrial generators',
    certifications: ['UL', 'ISO 9001', 'ASME'],
    api_related: false,
    iso_certified: true,
    export_ready: true,
    latin_america_experience: true,
    spanish_support: true,
    source_directory: 'GlobalSpec',
    source_url: '',
    contact_name: '—',
    contact_email: '—',
    contact_phone: '—',
    verification_status: 'Verified',
    notes: 'Sample Profile — placeholder record',
    last_contacted: '',
    relationship_status: 'Interested',
  },
  {
    id: 'SP-0007',
    company_name: 'Bayou Logistics & Customs',
    website: 'sample.example.com',
    state: 'LA',
    city: 'New Orleans',
    category: 'Logistics & Freight Forwarding',
    sub_category: 'Latin America export, customs',
    products_services:
      'Ocean freight forwarding, customs brokerage, hazardous materials, project cargo',
    certifications: ['CTPAT', 'IATA'],
    api_related: false,
    iso_certified: false,
    export_ready: true,
    latin_america_experience: true,
    spanish_support: true,
    source_directory: 'Internal Research',
    source_url: '',
    contact_name: '—',
    contact_email: '—',
    contact_phone: '—',
    verification_status: 'Pending Verification',
    notes: 'Sample Profile — placeholder record',
    last_contacted: '',
    relationship_status: 'Not Contacted',
  },
  {
    id: 'SP-0008',
    company_name: 'Permian Safety Equipment Co.',
    website: 'sample.example.com',
    state: 'TX',
    city: 'Odessa',
    category: 'Industrial Safety Equipment',
    sub_category: 'Gas detection, PPE, fire safety',
    products_services:
      'H2S monitors, fixed gas detection, fire suppression, industrial PPE',
    certifications: ['UL', 'OSHA', 'ISO 9001'],
    api_related: false,
    iso_certified: true,
    export_ready: true,
    latin_america_experience: false,
    spanish_support: false,
    source_directory: 'Thomasnet',
    source_url: '',
    contact_name: '—',
    contact_email: '—',
    contact_phone: '—',
    verification_status: 'Pending Verification',
    notes: 'Sample Profile — placeholder record',
    last_contacted: '',
    relationship_status: 'Not Contacted',
  },
]

export const sampleOutreach: OutreachRecord[] = [
  {
    supplier_id: 'SP-0001',
    company_name: 'Gulf Coast Valve & Flow Systems',
    contact_person: '—',
    email: '—',
    phone: '—',
    source: 'API Composite List',
    category: 'Valves & Flow Control',
    outreach_date: '',
    follow_up_date: '',
    status: 'Not Started',
    notes: 'Sample row',
    interested: false,
    approved_for_network: false,
  },
  {
    supplier_id: 'SP-0003',
    company_name: 'Houston Industrial Controls Group',
    contact_person: '—',
    email: '—',
    phone: '—',
    source: 'Thomasnet',
    category: 'Automation & Industrial Controls',
    outreach_date: '',
    follow_up_date: '',
    status: 'Awaiting Reply',
    notes: 'Sample row',
    interested: false,
    approved_for_network: false,
  },
  {
    supplier_id: 'SP-0006',
    company_name: 'American Power Distribution Systems',
    contact_person: '—',
    email: '—',
    phone: '—',
    source: 'GlobalSpec',
    category: 'Electrical Infrastructure',
    outreach_date: '',
    follow_up_date: '',
    status: 'Replied',
    notes: 'Sample row',
    interested: true,
    approved_for_network: false,
  },
]
